import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Col, Label } from 'reactstrap';
import ToggleSwitch from 'Components/pos2u/Buttons/ToggleSwitch';
import {
  EXPIRY_YEAR_OPTIONS,
  TOGGLE_SWITCH_SIZE,
} from 'pages/SettingsV2/SettingsConstants';
import SettingsSelect from 'pages/SettingsV2/SettingsSelect';
import { SettingsFormValues } from 'pages/SettingsV2/settingsTypes';
import { useSettings } from 'pages/SettingsV2/SettingsContext';
import SettingsV2SectionCard from 'pages/SettingsV2/SettingsV2SectionCard';

const LoyaltyPointsSectionV2 = () => {
  const { t } = useTranslation();
  const {
    fieldErrors,
    clearFieldError,
    validateField,
    isSectionAccessible,
    getSectionRestrictionNotice,
  } = useSettings();
  const { values, setFieldValue } = useFormikContext<SettingsFormValues>();
  const { isActive, expiryYear } = values.loyaltyPoints;
  const accessible = isSectionAccessible('loyaltyPoints');
  const notice = getSectionRestrictionNotice('loyaltyPoints');

  return (
    <SettingsV2SectionCard
      sectionKey="loyaltyPoints"
      title={t('Loyalty Points Settings')}
      icon="ri-medal-line"
      disabled={!accessible}
      notice={notice}
      headerActions={
        <ToggleSwitch
          id="loyalty-points-v2-active"
          checked={isActive}
          label={t('Enabled')}
          size={TOGGLE_SWITCH_SIZE}
          disabled={!accessible}
          wrapperClassName="flex-nowrap flex-shrink-0"
          onChange={(e) => {
            setFieldValue('loyaltyPoints.isActive', e.target.checked);
            clearFieldError('loyaltyPoints.expiryYear');
          }}
          onBlur={() => validateField('loyaltyPoints.expiryYear')}
        />
      }
    >
      <div className="mb-3 row">
        <Label
          htmlFor="loyalty-points-v2-expiry-year"
          className="col-sm-3 col-form-label"
        >
          {t('Points Expire Within')}
        </Label>
        <Col sm={9}>
          <SettingsSelect
            inputId="loyalty-points-v2-expiry-year"
            value={expiryYear}
            isDisabled={!isActive}
            onChange={(value) => {
              setFieldValue('loyaltyPoints.expiryYear', Number(value));
              clearFieldError('loyaltyPoints.expiryYear');
            }}
            options={EXPIRY_YEAR_OPTIONS.map((year) => ({
              value: year,
              label: `${year} ${t('year(s)')}`,
            }))}
            onBlur={() => validateField('loyaltyPoints.expiryYear')}
          />
          {fieldErrors['loyaltyPoints.expiryYear'] ? (
            <div className="text-danger mt-1 err-txt">
              {t(fieldErrors['loyaltyPoints.expiryYear'] as string)}
            </div>
          ) : null}
          <div className="text-muted fs-13 mt-2">
            {t(
              'Points are valid for x year(s) from the date earned, and the system will deduct them on December 31 at 23:59 of the year they expire'
            )}
          </div>
        </Col>
      </div>
    </SettingsV2SectionCard>
  );
};

export default LoyaltyPointsSectionV2;
